import { render, staticRenderFns } from "./DoctorDocumentPreviewModal.vue?vue&type=template&id=52e8e459&scoped=true"
import script from "./DoctorDocumentPreviewModal.vue?vue&type=script&lang=js"
export * from "./DoctorDocumentPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./DoctorDocumentPreviewModal.vue?vue&type=style&index=0&id=52e8e459&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e8e459",
  null
  
)

export default component.exports